import React, { useState, useEffect } from 'react';
import AddOrEditExploreDataForm from './addExploreData';
import { fetchAllExploreData } from './services/exploreDataService';
import Navbar from './navbar';
import Footer from './footer';
import { useNavigate } from 'react-router-dom';
import '../index.css';

const ExploreDataManager = () => {
  const [allExploreData, setAllExploreData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterSection, setFilterSection] = useState('');
  const [showFormModal, setShowFormModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [message, setMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // State for rows per page
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const fetchData = async () => {
    try {
      const response = await fetchAllExploreData();
      console.log('Response from fetchAllExploreData:', response);

      // response itself is the array of sections
      const exploreSections = Array.isArray(response) ? response : [];

      // Flatten each section's contentList into one unified array
      const flatData = exploreSections.flatMap((section) =>
        section.contentList.map((item) => ({
          ...item,
          text: item.content?.text || '',
          sectionName: section.sectionName,
        }))
      );

      console.log('Fetched Explore Data:', flatData);
      setAllExploreData(flatData);
      setFilteredData(flatData);
      setMessage('');
    } catch (error) {
      console.error('Fetch Error:', error);
      setMessage('Failed to fetch all explore data.');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle filtering by section and search term
 useEffect(() => {
  const filtered = allExploreData.filter((item) => {
    const matchesSection =
      filterSection === '' || item.sectionName.toLowerCase() === filterSection.toLowerCase();
    return matchesSection;
  });

  setFilteredData(filtered);
  setCurrentPage(1);
}, [filterSection, searchTerm, allExploreData]);


  const handleAdd = () => {
    setEditData(null);
    setShowFormModal(true);
  };

  const handleEdit = (item) => {
    setEditData(item);
    setShowFormModal(true);
  };

  const handleSuccess = (isEdit) => {
    setMessage(
      isEdit
        ? 'Explore data updated successfully!'
        : 'Explore data added successfully!'
    );
    setShowFormModal(false);
    setEditData(null);
    fetchData();
  };

  const handleError = (isEdit) => {
    setMessage(
      isEdit
        ? 'Failed to update explore data.'
        : 'Failed to add explore data.'
    );
  };

  const handleClose = () => {
    setShowFormModal(false);
    setEditData(null);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to the first page on size change
  };

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid explore-data-container">
         
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4 className="fw-bold">Explore Data Manager</h4>
           <h4></h4>
          </div>
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
           {/* Filters */}
          <div className="mb-3" style={{ width: '50%' }}>
            <div className="row">
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filterSection}
                  onChange={(e) => setFilterSection(e.target.value)}
                >
                  <option value="">All Sections</option>
                  {/* Populate sections dynamically based on data */}
                  {Array.from(
                      new Set(allExploreData.map((item) => item.sectionName))
                    ).map((section, index) => (
                      <option key={index} value={section}>
                        {section}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
            <button className="btn btn-primary" onClick={handleAdd}>
              Add Explore Data
            </button>
          </div>


          {/* Table */}
          <div>
            {currentItems.length === 0 ? (
              <p>No data available.</p>
            ) : (
              <div className="mb-4">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th style={{maxWidth: "100px"}}>Description</th>
                    <th>Type</th>
                    <th>Text</th>
                    <th>Status</th>
                    <th style={{maxWidth: "50px"}}>Background Image</th>
                    <th>Video Link</th>
                    <th>Section</th>
                    <th>Created On</th>
                    <th>Modified On</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.description}</td>
                      <td>{item.type}</td>
                      <td>{item.text}</td>
                      <td>{item.status}</td>
                      <td>{item.backgroundImage}</td>
                      <td>
                        {item.videoLink ? (
                          <a href={item.videoLink} target="_blank" rel="noopener noreferrer">
                            View
                          </a>
                        ) : (
                          'N/A'
                        )}
                      </td>
                      <td>{item.section}</td>
                      <td>{item.createdOn}</td>
                      <td>{item.modifiedOn}</td>
                      <td>
                        <button className="btn btn-secondary" onClick={() => handleEdit(item)}>
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            )}
          </div>

          {/* Pagination Controls */}
          <nav className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {pageNumbers.map((number) => (
                <li key={number} className="page-item">
                  <button
                    className={`page-link ${number === currentPage ? 'active' : ''}`}
                    onClick={() => paginate(number)}
                  >
                    {number}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === pageNumbers.length}
                >
                  Next
                </button>
              </li>
            </ul>
            
            <div className="d-flex justify-content-between align-items-center mb-3">
              <ul>
                Show{' '}
                <select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="form-select d-inline-block w-auto"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>{' '}
                entries
              </ul>
            </div>
          </nav>

          {/* Add/Edit Form Modal */}
          {showFormModal && (
            <div className="modal" style={{ display: 'block' }}>
              <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
                <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {editData ? 'Edit Explore Data' : 'Add Explore Data'}
                    </h5>
                    <button type="button" className="btn-close" onClick={handleClose}></button>
                  </div>
                  <div className="modal-body">
                    <AddOrEditExploreDataForm
                      initialData={editData}
                      onSuccess={() => handleSuccess(Boolean(editData))}
                      onError={() => handleError(Boolean(editData))}
                      onClose={handleClose}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExploreDataManager;
